import { faChevronDown } from '@awesome.me/kit-5231b03bd6/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ControlProps, components } from 'react-select';
import { ComboBoxPrediction, IsMulti } from '~/utilities';

export const Control = ({
  children,
  ...props
}: ControlProps<ComboBoxPrediction, IsMulti>) => (
  <components.Control {...props}>
    {children}
    <FontAwesomeIcon className="mr-2 text-neutral-90" icon={faChevronDown} />
  </components.Control>
);
